function ProductsSection() {
  const { SectionEyebrow } = window.AppComponents;
  const { insuranceProducts } = window.AppData.siteContent;

  return (
    <section id="products" className="py-9">
      <div className="mb-6 max-w-3xl">
        <SectionEyebrow>Popular categories</SectionEyebrow>
        <h2 className="mt-4 font-display text-4xl font-bold tracking-[-0.05em] text-ink md:text-5xl">
          Explore protection built around your everyday risks
        </h2>
        <p className="mt-4 text-base leading-8 text-slate-500">
          Browse top insurance lines with simplified guidance, strong insurer
          options, and quote journeys designed for speed.
        </p>
      </div>

      <div className="mb-6 overflow-hidden rounded-[28px] border border-white/80 bg-white/70 shadow-glow backdrop-blur-xl">
        <div className="relative">
          <img
            src="https://images.unsplash.com/photo-1624555130581-1d9cca783bc0?auto=format&fit=crop&w=1600&q=80"
            alt="Advisors and customers meeting around a table"
            className="h-[240px] w-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-ink/75 via-ink/35 to-transparent"></div>
          <div className="absolute inset-x-0 bottom-0 p-6 text-white">
            <p className="text-sm font-bold uppercase tracking-[0.18em] text-white/75">
              Expert Guidance
            </p>
            <p className="mt-2 max-w-xl font-display text-3xl font-bold tracking-[-0.04em]">
              Compare plans with real advisors, not confusing spreadsheets.
            </p>
          </div>
        </div>
      </div>

      <div className="grid gap-5 md:grid-cols-2 xl:grid-cols-4">
        {insuranceProducts.map((product) => (
          <article
            key={product.title}
            className="rounded-[26px] border border-white/80 bg-white/80 p-6 shadow-glow backdrop-blur-xl"
          >
            <div
              className={`mb-5 grid h-14 w-14 place-items-center rounded-[18px] bg-gradient-to-br ${product.accent} font-display font-bold text-white`}
            >
              {product.icon}
            </div>
            <h3 className="text-xl font-bold">{product.title}</h3>
            <p className="mt-3 leading-7 text-slate-500">{product.description}</p>
            <a href="#plans" className="mt-5 inline-block font-extrabold text-coral">
              See plans
            </a>
          </article>
        ))}
      </div>
    </section>
  );
}

window.AppSections = window.AppSections || {};
window.AppSections.ProductsSection = ProductsSection;
